var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4105",
    "data-name": "Rectangle 4105",
    width: 13.855,
    height: 13.816,
    fill: "#302f46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9678",
    "data-name": "Group 9678",
    transform: "translate(-746 -371.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(746 371.5)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11202",
    "data-name": "Group 11202",
    transform: "translate(759 384.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M6.24,107.643v1.382H.8a.873.873,0,0,1-.467-.114A.686.686,0,0,1,.25,107.8a.857.857,0,0,1,.487-.152c.036,0,.072,0,.109,0Z",
    transform: "translate(0 -101.425)",
    fill: "#302f46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M137.579,108.979a1.155,1.155,0,0,1-.348.061q-2.652.005-5.3,0h-.145V107.66h.149q2.652,0,5.3,0a1.221,1.221,0,0,1,.278.032.665.665,0,0,1,.51.6.678.678,0,0,1-.445.685",
    transform: "translate(-124.171 -101.442)",
    fill: "#302f46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M109.429,6.068v6.957a.97.97,0,0,1-.069.38.667.667,0,0,1-1.279-.189c-.013-.129-.02-.258-.02-.387q0-2.386,0-4.77V6q0-2.616,0-5.232a.739.739,0,0,1,.246-.6.636.636,0,0,1,.667-.122.641.641,0,0,1,.434.546,2.836,2.836,0,0,1,.021.377q0,2.549,0,5.1",
    transform: "translate(-101.819 0)",
    fill: "#302f46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogPlusIcon);
export default __webpack_public_path__ + "static/media/logPlusIcon.efd1d75445fd06ed5039656e81fec1cb.svg";
export { ForwardRef as ReactComponent };